import request from '../utils/request';

/**
 * 获取系统通知分页列表
 * @param {Object} params 查询参数
 * @returns {Promise} 请求结果
 */
export function getNotificationList(params) {
    console.log(params);
  return request({
    url: '/notifications/list',
    method: 'get',
    params
  });
}

// 获取管理员个人通知列表
export const listAdminNotifications = (queryDTO) => {
  return request({
    url: '/notifications/my-list',
    method: 'post',
    data: queryDTO
  });
};

/**
 * 创建系统通知
 * @param {Object} data 通知数据
 * @returns {Promise} 请求结果
 */
export function createNotification(data) {
  return request({
    url: '/notifications',
    method: 'post',
    data
  });
}

/**
 * 标记通知为已读
 * @param {number} id 通知ID
 * @returns {Promise} 请求结果
 */
export function markAsRead(id) {
  return request({
    url: `/notifications/${id}/read`,
    method: 'put'
  });
}
/**
 * 批量标记通知为已读
 * @param {number} id 通知ID
 * @returns {Promise} 请求结果
 */
export function markAllNotificationsAsRead() {
  return request({
    url: `/notifications/read/all`,
    method: 'put'
  });
}
 

/**
 * 删除通知
 * @param {number} id 通知ID
 * @returns {Promise} 请求结果
 */
export function deleteNotification(id) {
  return request({
    url: `/notifications/${id}`,
    method: 'delete'
  });
} 


/**
 * 获取管理员通知列表
 * @returns 
 */
export function getAdminNotificationList(param) {
  return request({
    url: `/notifications/my-list`,
    method: 'post',
    data: param
  });

 
}